import {
    SET_STATUSES,
    SET_EDIT_STATUS,
    SET_NEW_STATUS,
    SET_DELETE_STATUS,
    SET_DELETE_MULTI_STATUS,
    SET_LIST_STATUSES,
    SET_STATUS,
    RESET_ITEMS_STATUS,
    RESET_LIST_STATUSES,
} from "redux/constants/Statuses";

const initalAgreementState = {
    items: [],
    list: [],
    selected: {},
    loading: true,
};
const Statuses = (state = initalAgreementState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_STATUSES: {
            return { ...state, items: payload, loading: false };
        }
        case SET_LIST_STATUSES: {
            return { ...state, list: payload };
        }
        case SET_STATUS: {
            return { ...state, selected: payload };
        }
        case SET_NEW_STATUS: {
            return { ...state, items: [payload, ...state.items] };
        }

        case SET_EDIT_STATUS: {
            let list = [...state.items];

            try {
                let ind = list.findIndex((item) => item._id === payload._id);

                if (ind > -1) {
                    list[ind] = payload;
                }
            } catch (error) {}

            return { ...state, items: list };
        }

        case SET_DELETE_STATUS: {
            let list = state.items.filter((item) => item._id !== payload);

            return { ...state, items: list };
        }

        case SET_DELETE_MULTI_STATUS: {
            let arr = payload.split(",");
            let list = state.items.filter((item) => !arr.includes(item._id));

            return { ...state, items: list };
        }
        case RESET_LIST_STATUSES: {
            return { ...state, list: [] };
        }

        case RESET_ITEMS_STATUS: {
            return { ...state, items: [], loading: true };
        }

        default:
            return state;
    }
};

export default Statuses;
